import { LeadGenerationRequester, LeadGenerationRequesterLabels } from '@navio/nsdk';
import type { NoddiIconName } from 'noddi-ui-common';
import type { BadgeVariant } from 'noddi-ui-web';

// nsdk keys the labels by member name (`WORKER`), not by the API value (`worker`).
export const LEAD_REQUESTER_LABEL: Record<LeadGenerationRequester, string> = {
  [LeadGenerationRequester.WORKER]: LeadGenerationRequesterLabels.WORKER,
  [LeadGenerationRequester.CUSTOMER]: LeadGenerationRequesterLabels.CUSTOMER
};

export const LEAD_REQUESTER_ICON: Record<LeadGenerationRequester, NoddiIconName> = {
  [LeadGenerationRequester.WORKER]: 'Wrench',
  [LeadGenerationRequester.CUSTOMER]: 'User'
};

// Tells the two apart at a glance in the lead table; neither hue is a status.
export const LEAD_REQUESTER_BADGE_VARIANT: Record<LeadGenerationRequester, BadgeVariant> = {
  [LeadGenerationRequester.WORKER]: 'default',
  [LeadGenerationRequester.CUSTOMER]: 'info'
};
